import { Toggle } from '../../../utilities/toggle.js'

const BREAKPOINT = matchMedia('(min-width: 70rem)')

class NavMain extends Toggle {
  /**
   * Create new main nav
   * @param {HTMLLIElement} item Nav list item
   * @param {HTMLButtonElement} button Toggle button
   */
  constructor (item, button) {
    super(button)

    this.item = item
  }

  init () {
    super.init()

    // "Prepare" for dynamic event adding and removing.
    this.pointerOpen = this.pointerOpen.bind(this)
    this.pointerClose = this.pointerClose.bind(this)

    if (BREAKPOINT.matches) {
      this.close()
      this.addPointerListeners()
    }

    BREAKPOINT.addListener(event => {
      if (event.matches) {
        this.close()
        this.addPointerListeners()
      } else {
        this.removeRemoveListeners()
      }
    })
  }

  addPointerListeners () {
    this.item.addEventListener('pointerenter', this.pointerOpen)
    this.item.addEventListener('pointerleave', this.pointerClose)
  }

  removeRemoveListeners () {
    this.item.removeEventListener('pointerenter', this.pointerOpen)
    this.item.removeEventListener('pointerleave', this.pointerClose)
  }

  /**
   * Open with pointer
   * @param {PointerEvent} event Pointer event
   */
  pointerOpen (event) {
    if (event.pointerType !== 'touch') {
      this.open()
    }
  }

  /**
   * Close with pointer
   * @param {PointerEvent} event Pointer event
   */
  pointerClose (event) {
    if (event.pointerType !== 'touch') {
      this.close()
    }
  }
}

const items = document.querySelectorAll('.js-nav-main-item')

items.forEach(item => {
  const button = item.querySelector('.js-nav-main-button')
  new NavMain(item, button).init()
})
